import React from 'react'

function getOrderAsText(orders) {
    let orderText = ''

    orders.forEach(order => orderText += `${order.number}x ${order.description} \n`)

    return orderText
}
const OrderTableRows = ({orders, title}) => (
        <React.Fragment>
            <tr>
                <td colSpan="2" className="text-muted text-center">
                    <span className="font-italic">{title}</span>
                    <a href={`mailto:leverancier@leverancier.nl?SUBJECT=${title}&BODY=${encodeURI(getOrderAsText(orders))}`} target="_blank" className="icon-link"><i className="fas fa-shopping-cart ml-3"/></a>
                </td>
            </tr>

            {orders.map((order, index) => (
                <tr key={index}>
                    <td className="table-number text-center">{order.number}</td>
                    <td>{order.description}</td>
                </tr>
            ))}
        </React.Fragment>
)

export default OrderTableRows


// WEBPACK FOOTER //
// ./src/components/OrderTableRows.js